'use strict';

var $ = require('jquery');

/**
 * Sticky Bar functionality for PDP
 * Controls sticky bar visibility based on inline CTA viewport position
 * Mobile-only functionality
 */

var initialized = false;
var activeObserver = null;

/**
 * Get header height for sticky positioning calculations
 */
function getHeaderHeight() {
    var header = document.querySelector('.js-sticky-header-mobile');
    if (header) {
        return header.offsetHeight;
    }

    var headerHeight = getComputedStyle(document.body).getPropertyValue('--header-height');
    if (headerHeight) {
        return parseInt(headerHeight, 10);
    }

    return 70;
}

/**
 * Initialize Intersection Observer to track inline CTA visibility
 */
function initStickyBarObserver() {
    if (window.innerWidth > 768) {
        return;
    }

    if (activeObserver) {
        activeObserver.disconnect();
        activeObserver = null;
    }

    var body = document.body;
    var pdpFormMainButton = document.querySelector('.js-pdp_top_static_block .js-pdp-form_button');
    var backInStockBlock = document.querySelector('.js-pdp_bottom_static_block .js-backinstock');
    var pdpForm = document.querySelector('.js-pdp-form');
    var hasBackInStock = pdpForm && pdpForm.dataset.hasBackinstock === 'true';
    var shouldShowSticky = pdpFormMainButton || hasBackInStock;

    if (!shouldShowSticky || !('IntersectionObserver' in window)) {
        body.classList.remove('h-sticky_button');
        return;
    }

    var headerHeight = getHeaderHeight();
    var triggerOffset = headerHeight - 10;
    var stickyBlock = document.querySelector('.js-pdp-form_main_actions');
    var addToCartBlock = document.querySelector('.js-pdp_top_static_block');
    var backInStockStickyBlock = document.querySelector('.js-pdp_bottom_static_block .js-backinstock_sticky');

    var observeTarget = (hasBackInStock && !pdpFormMainButton)
        ? backInStockBlock
        : addToCartBlock;

    activeObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                body.classList.remove('h-sticky_button');
                if (backInStockBlock) {
                    backInStockBlock.style.setProperty('--backinstock-height', backInStockBlock.offsetHeight + 'px');
                }
                if (stickyBlock && addToCartBlock) {
                    addToCartBlock.style.setProperty('--add-to-cart-block-height', stickyBlock.offsetHeight + 'px');
                }
            } else {
                setTimeout(function() {
                    var heightTarget = (hasBackInStock && backInStockStickyBlock) ? backInStockStickyBlock : stickyBlock;
                    if (heightTarget) {
                        body.style.setProperty('--sticky-block-height', heightTarget.offsetHeight + 'px');
                    }
                }, 0);
                body.classList.add('h-sticky_button');
            }
        });
    }, {
        root: null,
        threshold: 0.1,
        rootMargin: '-' + triggerOffset + 'px 0px 0px 0px'
    });

    activeObserver.observe(observeTarget);
}

/**
 * Initialize sticky bar functionality
 */
function init() {
    if (initialized) {
        return;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStickyBarObserver);
    } else {
        initStickyBarObserver();
    }

    $(document).on('pdp.updated', function() {
        setTimeout(initStickyBarObserver, 0);
    });

    initialized = true;
}

/**
 * Module export
 */
module.exports = {
    init: init
};